import { CSSProperties } from 'react'
import styled from 'styled-components'
import ReactModal from 'react-modal'

import theme from 'theme_'
import { Font14 } from 'components/Typography'

export const StyledModalContent = styled(ReactModal)`
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  outline: none;
  @media ${theme.devices.tablet} {
    width: unset;
  }
`

export const StyledModalInner = styled.div`
  margin: auto;
  max-width: calc(100% - ${theme.spacing.base});
  width: 600px;
  max-height: 90vh;
  padding: ${theme.spacing.md} ${theme.spacing.md};
  border: none;
  border-radius: ${theme.spacing.xs};
  background-color: ${theme.colors.white};
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`

export const StyledModalMobileContent = styled(ReactModal)`
  display: flex;
  position: fixed;
  width: 100%;
  height: calc(100vh - calc(100vh - 100%));
  overflow-y: auto;
  min-height: 100vh;
  /* mobile viewport bug fix */
  min-height: -webkit-fill-available;
`

export const StyledModalMobileInner = styled.div<{
  innerContainerStyle: CSSProperties
}>`
  width: 100%;
  height: 100vh;
  /* mobile viewport bug fix */
  height: -webkit-fill-available;
  background-color: ${({ innerContainerStyle }) =>
    innerContainerStyle.backgroundColor};
  overflow: auto;
  z-index: ${theme.zIndex.loaderOverlay};
  animation: ${theme.animations.fadeIn} 0.2s ease;
  transition: all 0.2s ease;
`

export const StyledUniversalModalContent = styled(ReactModal)`
  display: flex;
  position: fixed;
  width: 100%;
  height: calc(100vh - calc(100vh - 100%));
  overflow-y: auto;
  min-height: 100vh;
  /* mobile viewport bug fix */
  min-height: -webkit-fill-available;
  @media ${theme.devices.tablet} {
    display: flex;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: unset;
    outline: none;
    height: auto;
    min-height: 100px;
  }
`

export const StyledUniversalModalInner = styled.div`
  width: 100%;
  height: 100vh;
  /* mobile viewport bug fix */
  height: -webkit-fill-available;
  background-color: ${theme.colors.white};
  overflow: auto;
  z-index: ${theme.zIndex.loaderOverlay};
  animation: ${theme.animations.fadeIn} 0.2s ease;
  transition: all 0.2s ease;
  @media ${theme.devices.tablet} {
    margin: auto;
    max-width: calc(100% - ${theme.spacing.base});
    width: 600px;
    padding: ${theme.spacing.md} ${theme.spacing.md};
    border: none;
    border-radius: ${theme.spacing.xs};
    background-color: ${theme.colors.white};
    height: auto;
  }
`

export const ModalTitle = styled.div`
  margin-bottom: ${theme.spacing.xxxl};
  text-align: center;
`

export const ModalIconWrapper = styled.div`
  text-align: center;
`

export const ModalText = styled.div`
  ${Font14};
  line-height: 20px;
  color: ${theme.colors.otterWarmBlack};
  text-align: center;
  margin-bottom: ${theme.spacing.lg};
`

export const ModalButtonsWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${theme.spacing.xl};
  justify-content: center;
  align-items: center;

  > button:nth-child(2) {
    margin-top: ${theme.spacing.base};
    margin-left: 0;
  }

  @media ${theme.devices.desktop} {
    flex-direction: row;

    > button:nth-child(2) {
      margin-top: 0;
      margin-left: ${theme.spacing.base};
    }
  }
`

export const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const ModalContentContainer = styled.div`
  margin-top: -24px; // merging content with a space occupied by header with X button
`

export const ModalCloseBtn = styled.button`
  background-color: transparent;
  border: 0;
  outline: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
`
